// import React, { useEffect, useState } from "react";
// import {
//     Box,
//     Typography,
//     Table,
//     TableHead,
//     TableRow,
//     TableCell,
//     TableBody,
//     IconButton,
//     Tooltip,
//     Snackbar,
//     Alert,
//     Dialog,
//     DialogTitle,
//     DialogContent,
//     DialogActions,
//     Button,
//     Accordion,
//     AccordionSummary,
//     AccordionDetails,
// } from "@mui/material";
// import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
// import VisibilityIcon from "@mui/icons-material/Visibility";
// import LockIcon from "@mui/icons-material/Lock";
// import CheckCircleIcon from "@mui/icons-material/CheckCircle";
// import axios from "axios";
// import { useNavigate } from "react-router-dom";
// import { API_BASE_URL } from "../../../utils";
// import { useAuthHeaders } from "../../../components/Token";
// import MoreVertIcon from "@mui/icons-material/MoreVert";
// import Menu from "@mui/material/Menu";
// import MenuItem from "@mui/material/MenuItem";


// const VendorProductPage = () => {
//     const headers = useAuthHeaders();
//     const navigate = useNavigate();
//     const [vendorProducts, setVendorProducts] = useState([]);
//     const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });
//     const [dialogOpen, setDialogOpen] = useState(false);
//     const [selectedProductId, setSelectedProductId] = useState(null);
//     const [anchorEl, setAnchorEl] = useState(null);
//     const [menuProductId, setMenuProductId] = useState(null);
//     const openMenu = Boolean(anchorEl);
//     const handleMenuOpen = (event, productId) => {
//         setAnchorEl(event.currentTarget);
//         setMenuProductId(productId);
//     };

//     const handleMenuClose = () => {
//         setAnchorEl(null);
//         setMenuProductId(null);
//     };


//     useEffect(() => {
//         const fetchData = async () => {
//             try {
//                 const res = await axios.get(`${API_BASE_URL}/admin/vendorproducts`, { headers });
//                 setVendorProducts(res?.data?.products || []);
//             } catch (err) {
//                 console.error("Error fetching vendor data:", err);
//             }
//         };
//         fetchData();
//     }, []);

//     const handleApprove = async (productId) => {
//         try {
//             const response = await axios.patch(
//                 `${API_BASE_URL}/admin/product/${productId}/review`,
//                 { action: "approve" },
//                 { headers }
//             );
//             if (response.data.success) {
//                 setSnackbar({ open: true, message: response.data.message, severity: "success" });
//                 setVendorProducts((prev) =>
//                     prev.map((p) => (p._id === productId ? { ...p, productStatus: "APPROVED" } : p))
//                 );
//             } else {
//                 setSnackbar({ open: true, message: response.message, severity: "error" });
//             }
//         } catch (error) {
//             console.error("Approval error:", error);
//             setSnackbar({ open: true, message: error.response?.data?.message || "Error approving product", severity: "error" });
//         }
//     };

//     const handleDialogOpen = (productId) => {
//         setSelectedProductId(productId);
//         setDialogOpen(true);
//     };

//     const handleDialogClose = () => {
//         setDialogOpen(false);
//         setSelectedProductId(null);
//     };

//     const handleConfirmApproval = () => {
//         if (selectedProductId) {
//             handleApprove(selectedProductId);
//         }
//         handleDialogClose();
//     };

//     return (
//         <Box p={3}>
//             <Typography variant="h5" gutterBottom>
//                 Vendor Product List
//             </Typography>

//             <Table size="small" sx={{ bg: "#eeee" }}>
//                 <TableHead>
//                     <TableRow>
//                         <TableCell sx={{ py: 0.5, px: 1, fontSize: "0.875rem" }}>Part Number</TableCell>
//                         <TableCell sx={{ py: 0.5, px: 1, fontSize: "0.875rem" }}>Company</TableCell>
//                         <TableCell sx={{ py: 0.5, px: 1, fontSize: "0.875rem" }}>Category</TableCell>
//                         <TableCell sx={{ py: 0.5, px: 1, fontSize: "0.875rem" }}>Sub Category</TableCell>
//                         <TableCell sx={{ py: 0.5, px: 1, fontSize: "0.875rem" }}>Quantity</TableCell>
//                         <TableCell sx={{ py: 0.5, px: 1, fontSize: "0.875rem" }}>Weight Per Piece</TableCell>
//                         <TableCell sx={{ py: 0.5, px: 1, fontSize: "0.875rem" }}>Product Weight</TableCell>
//                         <TableCell sx={{ py: 0.5, px: 1, fontSize: "0.875rem" }}>Box of Quantity</TableCell>
//                         <TableCell sx={{ py: 0.5, px: 1, fontSize: "0.875rem" }}>Sale Price</TableCell>
//                         <TableCell sx={{ py: 0.5, px: 1, fontSize: "0.875rem" }}>Status</TableCell>

//                         <TableCell align="center" sx={{ py: 0.5, px: 1, fontSize: "0.875rem" }}>
//                             Actions
//                         </TableCell>
//                     </TableRow>
//                 </TableHead>
//                 <TableBody>
//                     {vendorProducts.map((product) => {
//                         const vendor = product.vendor;
//                         return (
//                             <TableRow
//                                 key={product._id}
//                                 sx={{
//                                     "& .MuiTableCell-root": { py: 0.5, px: 1, fontSize: "0.875rem" },
//                                 }}
//                             >
//                                 <TableCell>{product.partNumber}</TableCell>
//                                 <TableCell>{vendor.companyName}</TableCell>
//                                 <TableCell>{product.category?.name} </TableCell>
//                                 <TableCell>{product.subcategoryname?.name}</TableCell>
//                                 <TableCell>{product.quantity}</TableCell>
//                                 <TableCell>{product.weightperpiece}</TableCell>
//                                 <TableCell>{product.productweight}</TableCell>
//                                 <TableCell>{product.boq}</TableCell>
//                                 <TableCell>{product.saleprice}</TableCell>
//                                 <TableCell>
//                                     <Box
//                                         component="span"
//                                         sx={{
//                                             backgroundColor: product.productStatus === "APPROVED" ? "success.main" : "warning.main",
//                                             color: "white",
//                                             px: 1,
//                                             py: 0.5,
//                                             borderRadius: 1,
//                                             fontSize: "0.75rem",
//                                             textTransform: "uppercase",
//                                         }}
//                                     >
//                                         {product.productStatus}
//                                     </Box>
//                                 </TableCell>


//                                 {/* Actions Column */}
//                                 <TableCell >
//                                     {/* <Box>

//                                         <Tooltip title="View Product">
//                                             <IconButton
//                                                 size="small"
//                                                 color="primary"
//                                                 onClick={() => {
//                                                     navigate(`/newProductsDetials/${product._id}`);
//                                                 }}
//                                             >
//                                                 <VisibilityIcon fontSize="small" />
//                                             </IconButton>
//                                         </Tooltip>
//                                     </Box>
//                                     <Box>

//                                         <Tooltip title="Set Permissions">
//                                             <IconButton
//                                                 size="small"
//                                                 color="secondary"
//                                                 onClick={() => navigate(`/vendor-request/vendor-permission/${vendor._id}`)}
//                                             >
//                                                 <LockIcon fontSize="small" />
//                                             </IconButton>
//                                         </Tooltip>
//                                     </Box>
//                                     <Box>

//                                         {product.productStatus !== "APPROVED" && (
//                                             <Tooltip title="Approve Product">
//                                                 <IconButton
//                                                     size="small"
//                                                     color="success"
//                                                     onClick={() => handleDialogOpen(product._id)}
//                                                 >
//                                                     <CheckCircleIcon fontSize="small" />
//                                                 </IconButton>
//                                             </Tooltip>
//                                         )}
//                                     </Box> */}

//                                     <IconButton onClick={(e) => handleMenuOpen(e, product._id)}>
//                                         <MoreVertIcon fontSize="small" />
//                                     </IconButton>
//                                     <Menu
//                                         anchorEl={anchorEl}
//                                         open={openMenu && menuProductId === product._id}
//                                         onClose={handleMenuClose}
//                                         anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
//                                         transformOrigin={{ vertical: "top", horizontal: "right" }}
//                                     >
//                                         <MenuItem
//                                             onClick={() => {
//                                                 navigate(`/vendor-product/view/${product._id}`);
//                                                 handleMenuClose();
//                                             }}
//                                         >
//                                             View Product
//                                         </MenuItem>

//                                         <MenuItem
//                                             onClick={() => {
//                                                 navigate(`/vendor-request/vendor-permission/${product.vendor._id}`);
//                                                 handleMenuClose();
//                                             }}
//                                         >
//                                             Set Permissions
//                                         </MenuItem>

//                                         {product.productStatus !== "APPROVED" && (
//                                             <MenuItem
//                                                 onClick={() => {
//                                                     handleDialogOpen(product._id);
//                                                     handleMenuClose();
//                                                 }}
//                                             >
//                                                 Approve Product
//                                             </MenuItem>
//                                         )}
//                                     </Menu>

//                                 </TableCell>
//                             </TableRow>
//                         );
//                     })}
//                 </TableBody>
//             </Table>

//             {/* Snackbar for feedback */}
//             <Snackbar
//                 open={snackbar.open}
//                 autoHideDuration={4000}
//                 onClose={() => setSnackbar({ ...snackbar, open: false })}
//                 anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
//             >
//                 <Alert
//                     severity={snackbar.severity}
//                     onClose={() => setSnackbar({ ...snackbar, open: false })}
//                     sx={{ fontSize: "0.875rem" }}
//                 >
//                     {snackbar.message}
//                 </Alert>
//             </Snackbar>

//             {/* Approval Confirmation Dialog */}
//             <Dialog open={dialogOpen} onClose={handleDialogClose} maxWidth="xs" fullWidth>
//                 <DialogTitle>Confirm Approval</DialogTitle>
//                 <DialogContent>
//                     <Typography>Are you sure you want to approve this product?</Typography>
//                 </DialogContent>
//                 <DialogActions>
//                     <Button onClick={handleDialogClose} color="inherit" size="small">
//                         Cancel
//                     </Button>
//                     <Button onClick={handleConfirmApproval} variant="contained" color="success" size="small">
//                         Approve
//                     </Button>
//                 </DialogActions>
//             </Dialog>
//         </Box>
//     );
// };

// export default VendorProductPage;


import React, { useEffect, useState } from "react";
import {
    Box,
    Typography,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    IconButton,
    Tooltip,
    Snackbar,
    Alert,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Menu,
    MenuItem,
    styled,
    tableCellClasses,
    TableContainer,
    Paper,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import VisibilityIcon from "@mui/icons-material/Visibility";
import LockIcon from "@mui/icons-material/Lock";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { API_BASE_URL } from "../../../utils";
import { useAuthHeaders } from "../../../components/Token";

// Styled components
const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        // backgroundColor: theme.palette.common.black,
        // color: theme.palette.common.white,
        fontSize: 12,
        fontWeight: 700,
        padding: 10

    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 12,
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&:nth-of-type(odd)": {
        backgroundColor: theme.palette.action.hover,
    },
    "&:last-child td, &:last-child th": {
        border: 0,
    },
}));

const VendorProductPage = () => {
    // const headers = useAuthHeaders();
    const navigate = useNavigate();
    const [vendorProducts, setVendorProducts] = useState([]);
    const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });
    const [dialogOpen, setDialogOpen] = useState(false);
    const [selectedProductId, setSelectedProductId] = useState(null);
    const [anchorEl, setAnchorEl] = useState(null);
    const [menuProductId, setMenuProductId] = useState(null);
    const header = localStorage.getItem("adminId")
    const openMenu = Boolean(anchorEl);

    const handleMenuOpen = (event, productId) => {
        setAnchorEl(event.currentTarget);
        setMenuProductId(productId);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
        setMenuProductId(null);
    };

    const headers = {
        Authorization: `Bearer ${header}`,
    };
    useEffect(() => {
        const fetchData = async () => {
            try {
                const res = await axios.get(`${API_BASE_URL}/admin/vendorproducts`, { headers });
                setVendorProducts(res?.data?.products || []);
            } catch (err) {
                console.error("Error fetching vendor data:", err);
            }
        };

        if (headers) fetchData();
    }, []);

    const handleApprove = async (productId) => {
        try {

            const response = await axios.patch(
                `${API_BASE_URL}/admin/product/${productId}/review`,
                { action: "approve" },
                { headers }
            );
            if (response.data.success) {
                setSnackbar({ open: true, message: response.data.message, severity: "success" });
                setVendorProducts((prev) =>
                    prev.map((p) => (p._id === productId ? { ...p, productStatus: "APPROVED" } : p))
                );
            } else {
                setSnackbar({ open: true, message: response.message, severity: "error" });
            }
        } catch (error) {
            console.error("Approval error:", error);
            setSnackbar({
                open: true,
                message: error.response?.data?.message || "Error approving product",
                severity: "error",
            });
        }
    };

    const handleDialogOpen = (productId) => {
        setSelectedProductId(productId);
        setDialogOpen(true);
    };

    const handleDialogClose = () => {
        setDialogOpen(false);
        setSelectedProductId(null);
    };

    const handleConfirmApproval = () => {
        if (selectedProductId) {
            handleApprove(selectedProductId);
        }
        handleDialogClose();
    };

    return (
        <Box p={3}>
            <Typography variant="h5" gutterBottom>
                Vendor Product List
            </Typography>
            <TableContainer component={Paper}>

                <Table sx={{ backgroundColor: "#eeeeee", minWidth: 700 }} ria-label="customized table">
                    <TableHead>
                        <TableRow>
                            <StyledTableCell>Part Number</StyledTableCell>
                            <StyledTableCell>Category</StyledTableCell>
                            <StyledTableCell>Sub Category</StyledTableCell>
                            <StyledTableCell>Quantity</StyledTableCell>
                            <StyledTableCell>Weight Per Piece</StyledTableCell>
                            <StyledTableCell>Product Weight</StyledTableCell>
                            <StyledTableCell>Box of Quantity</StyledTableCell>
                            <StyledTableCell>Sale Price</StyledTableCell>
                            <StyledTableCell>Vendor</StyledTableCell>
                            <StyledTableCell>Status</StyledTableCell>
                            <StyledTableCell align="center">Actions</StyledTableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {vendorProducts.map((product) => {
                            const vendor = product.vendor;
                            return (
                                <StyledTableRow key={product._id}>
                                    <StyledTableCell>{product.partNumber}</StyledTableCell>

                                    <StyledTableCell>{product.category?.name}</StyledTableCell>
                                    <StyledTableCell>{product.subcategoryname?.name}</StyledTableCell>
                                    <StyledTableCell>{product.quantity}</StyledTableCell>
                                    <StyledTableCell>{product.weightperpiece}</StyledTableCell>
                                    <StyledTableCell>{product.productweight}</StyledTableCell>
                                    <StyledTableCell>{product.boq}</StyledTableCell>
                                    <StyledTableCell>{product.saleprice}</StyledTableCell>
                                    <StyledTableCell>{vendor?.companyName}</StyledTableCell>
                                    <StyledTableCell>
                                        <Box
                                            component="span"
                                            sx={{
                                                backgroundColor:
                                                    product.productStatus === "APPROVED"
                                                        ? "success.main"
                                                        : "warning.main",
                                                color: "white",
                                                px: 1,
                                                py: 0.5,
                                                borderRadius: 1,
                                                fontSize: "10px",
                                                textTransform: "uppercase",
                                            }}
                                        >
                                            {product.productStatus}
                                        </Box>
                                    </StyledTableCell>

                                    <StyledTableCell align="center">
                                        <IconButton onClick={(e) => handleMenuOpen(e, product._id)}>
                                            <MoreVertIcon fontSize="small" />
                                        </IconButton>
                                        <Menu
                                            anchorEl={anchorEl}
                                            open={openMenu && menuProductId === product._id}
                                            onClose={handleMenuClose}
                                            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                                            transformOrigin={{ vertical: "top", horizontal: "right" }}
                                        >
                                            <MenuItem
                                                onClick={() => {
                                                    navigate(`/newProductsDetials/${product._id}`);
                                                    handleMenuClose();
                                                }}
                                            >
                                                <VisibilityIcon fontSize="small" sx={{ mr: 1 }} />
                                                View Product
                                            </MenuItem>

                                            <MenuItem
                                                onClick={() => {
                                                    navigate(`/vendor-request/vendor-permission/${vendor._id}`);
                                                    handleMenuClose();
                                                }}
                                            >
                                                <LockIcon fontSize="small" sx={{ mr: 1 }} />
                                                Set Permissions
                                            </MenuItem>

                                            {product.productStatus !== "APPROVED" && (
                                                <MenuItem
                                                    onClick={() => {
                                                        handleDialogOpen(product._id);
                                                        handleMenuClose();
                                                    }}
                                                >
                                                    <CheckCircleIcon fontSize="small" sx={{ mr: 1 }} />
                                                    Approve Product
                                                </MenuItem>
                                            )}
                                        </Menu>
                                    </StyledTableCell>
                                </StyledTableRow>
                            );
                        })}
                    </TableBody>
                </Table>
            </TableContainer>

            <Snackbar
                open={snackbar.open}
                autoHideDuration={4000}
                onClose={() => setSnackbar({ ...snackbar, open: false })}
                anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
            >
                <Alert
                    severity={snackbar.severity}
                    onClose={() => setSnackbar({ ...snackbar, open: false })}
                    sx={{ fontSize: "0.875rem" }}
                >
                    {snackbar.message}
                </Alert>
            </Snackbar>

            <Dialog open={dialogOpen} onClose={handleDialogClose} maxWidth="xs" fullWidth>
                <DialogTitle>Confirm Approval</DialogTitle>
                <DialogContent>
                    <Typography>Are you sure you want to approve this product?</Typography>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleDialogClose} color="inherit" size="small">
                        Cancel
                    </Button>
                    <Button onClick={handleConfirmApproval} variant="contained" color="success" size="small">
                        Approve
                    </Button>
                </DialogActions>
            </Dialog>
        </Box>
    );
};

export default VendorProductPage;
